import React from 'react';
import BetHistory from '../components/BetHistory';

const History: React.FC = () => {
  return <BetHistory />;
};

export default History;